import React from 'react';
import {
  ActiveStepText, ProgressMeta, ProgressWrap, Segment,
  SegmentLabel, SegmentLabels, SegmentTrack,
} from './ProgressBar.styles';

export default function ProgressBar({ activeStep, steps }) {
  const items = steps.map((step, index) => ({
    step,
    completed: activeStep > index + 1,
    active: activeStep === index + 1,
  }));
  const activeLabel = steps[activeStep - 1];

  return (
    <ProgressWrap>
      <ProgressMeta>{`Passo ${activeStep} di ${steps.length}`}</ProgressMeta>
      <SegmentTrack>
        {items.map(({ step, completed, active }) => (
          <Segment key={step} $completed={completed} $active={active} />
        ))}
      </SegmentTrack>
      <SegmentLabels>
        {items.map(({ step, completed, active }) => (
          <SegmentLabel key={step} $completed={completed} $active={active}>
            {step}
          </SegmentLabel>
        ))}
      </SegmentLabels>
      {activeLabel && <ActiveStepText>{activeLabel}</ActiveStepText>}
    </ProgressWrap>
  );
}
